import ScrollLinksHandler from "../component/_scroll-links";

export default class Forms {
	static init() {
		setTimeout(function () {
			ScrollLinksHandler.scrollToElement(document.querySelector('.form--has-errors, #form-success-message'), -30);
		}, 100);

        // Add a single event listener to the document for 'invalid' events during the capturing phase
        document.addEventListener(
            'invalid',
            (event) => {
                if (event.target.closest('form.form')) {
                    event.target.classList.add('was-validated');
                }
            },
            true // Use the capturing phase since 'invalid' events don't bubble
        );
	}
}
